import { useMemo } from 'react';
import { useStoreState } from '@/store';
import { filterFormState } from '@/components/Form/utils';

/**
 * Hooks into store and filters the form state
 * @returns {object} Filtered form state for API use
 */
// TODO: Proper type can be added after @/components/Form/utils is typed
export const useFilteredFormState = (): unknown => {
  const formState = useStoreState(store => store.form);

  return useMemo(() => {
    return filterFormState(formState);
  }, [formState]);
};
